import React from "react";
import { Box } from "@mui/material";
import { scrollListSx, scrollPanelSx } from "../../theme/scrollStyles";

const SCROLL_VARIANT_SX = {
  list: scrollListSx,
  panel: scrollPanelSx,
};

/**
 * Scroll container; scrollbar look comes from globalScrollbarStyles (App.js).
 * @param {'list' | 'panel'} variant
 */
const NiceScrollBox = ({
  variant = "list",
  component = "div",
  sx,
  children,
  ...props
}) => (
  <Box
    component={component}
    sx={[SCROLL_VARIANT_SX[variant] ?? scrollListSx, ...(sx ? (Array.isArray(sx) ? sx : [sx]) : [])]}
    {...props}
  >
    {children}
  </Box>
);

export default NiceScrollBox;
